import { Button } from "antd";
import { ReactNode } from "react";
import WaryIcon from "../../assets/icons/WaryIcon";
import { CustomModalProps } from "../../types";
import CustomModal from "./CustomModal";

type Props = {
  data?: any;
  deleteLoading: boolean;
  deleteTitle?: string;
  questionText?: string;
  buttonText?: string;
  handleYes: (val: any) => void;
  children?: ReactNode;
  alertClassName?: string;
  hideAlert?: boolean;
  closable?: boolean;
} & CustomModalProps;

export default function ConfirmModal({
  data,
  deleteLoading,
  deleteTitle = "Delete This.",
  questionText = "Are sure to delete this item?",
  buttonText = "Delete",
  alertClassName = "",
  handleYes,
  handleClose,
  disableCloseBtn,
  disabled,
  children,
  hideAlert,
  closable = false,
  ...rest
}: Props) {
  return (
    <CustomModal
      width={300}
      handleClose={handleClose}
      closable={closable}
      {...rest}
    >
      {!hideAlert ? (
        <div
          className={`flex-col justify-start items-center gap-2.5 flex ${alertClassName}`}
        >
          <div className="w-[52px] h-[52px] relative">
            <div className="w-[52px] h-[52px] left-0 top-0 absolute bg-[#fff4f4] rounded-full" />
            <div className="w-6 h-6 left-[14px] top-[14px] absolute">
              <WaryIcon />
            </div>
          </div>
          <div className="text-center text-[#3d4a5c] text-base font-medium font-['Inter'] leading-normal">
            {deleteTitle}
          </div>
        </div>
      ) : null}

      {children}

      <div className="w-full justify-center items-center inline-flex gap-2 pt-6 ">
        <Button
          onClick={() => handleClose()}
          disabled={disableCloseBtn}
          className="cancel-btn"
        >
          Cancel
        </Button>
        <Button
          onClick={() => handleYes(data)}
          type="primary"
          loading={deleteLoading}
          disabled={disabled}
        >
          {buttonText}
        </Button>
      </div>
    </CustomModal>
  );
}
